module.exports = __webpack_public_path__ + "static/media/smartmodem.19bfc274.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/smartmodem.png
 ** module id = 1306
 ** module chunks = 0
 **/